var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-content-loading", { attrs: { width: 700, height: 350 } }, [
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "2.77778" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "103" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "203" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "303" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "403" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "503" },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: { rx: "1", height: "340", width: "94", y: "2", x: "603" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }